var _defs, _path, _g, _ellipse, _path2, _path3, _rect, _rect2, _rect3, _circle, _circle2, _rect4, _rect5, _rect6, _rect7, _path4, _path5, _ellipse2, _ellipse3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon, _path14, _path15, _path16, _ellipse4, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect8, _rect9, _rect10, _path27, _path28, _path29, _rect11, _path30, _rect12, _rect13, _path31, _polygon2, _polygon3, _path32, _circle3, _polygon4, _path33, _path34, _circle4, _circle5, _path35, _ellipse5, _path36, _ellipse6, _path37, _g2, _path38, _circle6, _ellipse7, _ellipse8, _path39, _path40, _path41, _path42, _path43, _path44, _ellipse9, _path45, _ellipse10, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMigration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fc4a0d9a-3c56-4cab-9c75-a9aad3df7d95",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a6f0c901-fb97-4cff-aac7-ab37a27326d8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e4149f13-a63b-4ecc-9778-cb17953cac0b",
    "data-name": "SVGID",
    d: "M213.49,147.54S-15.11,264.24,50.43,412.91c0,0,43.17,167.86,306.94,121.5L744.23,496S838.76,494.9,826,383c-4.4-38.39-26.88-72.14-59.74-92.48-18-11.16-35.75-27.45-37.86-49a23.26,23.26,0,0,0-.43-2.88C724.64,223.71,694.64,109.83,536.41,74,536.41,74,403.73,24.45,213.49,147.54Z",
    fill: "#EC1C24",
    opacity: 0.23
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a0adbed9-e3f6-4d75-b2a6-34748ce83bc1",
    "data-name": "SVGID",
    d: "M213.49,147.54S-15.11,264.24,50.43,412.91c0,0,43.17,167.86,306.94,121.5L744.23,496S838.76,494.9,826,383c-4.4-38.39-26.88-72.14-59.74-92.48-18-11.16-35.75-27.45-37.86-49a23.26,23.26,0,0,0-.43-2.88C724.64,223.71,694.64,109.83,536.41,74,536.41,74,403.73,24.45,213.49,147.54Z",
    fill: "#EC1C24",
    opacity: 0.23
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a6f0c901-fb97-4cff-aac7-ab37a27326d8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M546.05,236.25l74.09,44.48,70.56-21.61a1.7,1.7,0,0,0,.37-3.09h0a54.45,54.45,0,0,0-22.62-7.5Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.05,236.25l74.09,44.48,70.56-21.61a1.7,1.7,0,0,0,.37-3.09h0a54.45,54.45,0,0,0-22.62-7.5Z",
    fill: "#fff",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.46,249.72,609.3,270,554.52,237.1l113.93,11.43A54.86,54.86,0,0,1,675.46,249.72Z",
    fill: "#EC1C24",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.13,356l1,.57a31.31,31.31,0,0,0,23.22,3.64l83.58-19.5a13.47,13.47,0,0,1,10,1.57l4.78,2.87a1.79,1.79,0,0,1,.51,2.6l-42.34,56.67-6.14,8.15-79.76-47.87Z",
    fill: "#EC1C24",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.73,377.27l-304.88-183a272,272,0,0,1-48.43-37.06l-37.23-35.8a9,9,0,0,1-1.42-1.73h0a9.41,9.41,0,0,1,9-14.41L382.86,111A70,70,0,0,1,411,120.49L878.77,401.25a6,6,0,0,1,2.42,2.77h0a6,6,0,0,1-5,8.27l-9.47.72A255.75,255.75,0,0,1,715.73,377.27Z",
    fill: "#EC1C24",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.26,370.47l-338-202.9a301,301,0,0,1-53.69-41.09l-21.08-20.26a9.34,9.34,0,0,1,5.33-.94L382.86,111A70,70,0,0,1,411,120.49L878.77,401.25a6,6,0,0,1,2.42,2.77,5.93,5.93,0,0,1-1.54,6.76A283.45,283.45,0,0,1,740.26,370.47Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.87,129.76l-36.06-21.64,25.1,2.75,16.39,9.83a5.29,5.29,0,0,1,1.81,7.25h0A5.28,5.28,0,0,1,393.87,129.76Z",
    fill: "#EC1C24",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("rect", {
    x: 440.04,
    y: 155.92,
    width: 7.76,
    height: 7.76,
    rx: 0.89,
    transform: "translate(145.56 -205.69) rotate(30.98)",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.81,
    y: 167.79,
    width: 7.76,
    height: 7.76,
    rx: 0.89,
    transform: "translate(154.45 -214.15) rotate(30.97)",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.58,
    y: 179.65,
    width: 7.76,
    height: 7.76,
    rx: 0.89,
    transform: "matrix(0.86, 0.51, -0.51, 0.86, 163.39, -222.64)",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.35,
    y: 191.52,
    width: 7.76,
    height: 7.76,
    rx: 0.89,
    transform: "translate(172.3 -231.11) rotate(30.97)",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.12,
    y: 203.39,
    width: 7.76,
    height: 7.76,
    rx: 0.89,
    transform: "translate(181.26 -239.62) rotate(30.98)",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.89,
    y: 215.25,
    width: 7.76,
    height: 7.76,
    rx: 0.89,
    transform: "translate(190.19 -248.1) rotate(30.98)",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.66,
    y: 227.12,
    width: 7.76,
    height: 7.76,
    rx: 0.89,
    transform: "translate(199.08 -256.56) rotate(30.97)",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 578.43,
    y: 238.98,
    width: 7.76,
    height: 7.76,
    rx: 0.89,
    transform: "translate(208 -265.04) rotate(30.97)",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.2,
    y: 250.85,
    width: 7.76,
    height: 7.76,
    rx: 0.89,
    transform: "translate(216.93 -273.52) rotate(30.97)",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.97,
    y: 262.72,
    width: 7.76,
    height: 7.76,
    rx: 0.89,
    transform: "translate(225.89 -282.03) rotate(30.98)",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.74,
    y: 274.58,
    width: 7.76,
    height: 7.76,
    rx: 0.89,
    transform: "translate(234.82 -290.51) rotate(30.98)",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 657.51,
    y: 286.45,
    width: 7.76,
    height: 7.76,
    rx: 0.89,
    transform: "matrix(0.86, 0.51, -0.51, 0.86, 243.7, -298.96)",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 677.28,
    y: 298.31,
    width: 7.76,
    height: 7.76,
    rx: 0.89,
    transform: "translate(252.63 -307.45) rotate(30.97)",
    fill: "#EC1C24"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M512.94,224,627,292.52,648.36,402a3.54,3.54,0,0,1-5.3,3.71l-2.78-1.67a60.15,60.15,0,0,1-19.07-18.16Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.94,224,627,292.52,648.36,402a3.54,3.54,0,0,1-5.3,3.71l-2.78-1.67a60.15,60.15,0,0,1-19.07-18.16Z",
    fill: "#fff",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.64,388.57a3.81,3.81,0,0,1-.11,1.79c-1.17-1.44-2.29-2.92-3.32-4.46L512.94,224l90.19,54.14Z",
    fill: "#EC1C24",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "840.28 385.89 880.44 410 888.49 451.28 881.03 446.81 840.28 385.89",
    fill: "#EC1C24",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.82,
    y: 38.75,
    width: 14.84,
    height: 570.59,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.5,
    y: 38.75,
    width: 14.84,
    height: 570.59,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.49,
    y: -207.62,
    width: 15.19,
    height: 790.89,
    transform: "translate(614.9 -239.26) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.65,
    y: 23.2,
    width: 702.75,
    height: 598.92,
    fill: "#bbdefb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "50.38 617.19 19.1 617.19 425.28 -7.86 456.56 -7.86 50.38 617.19",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "564.99 617.19 533.71 617.19 939.9 -7.86 971.18 -7.86 564.99 617.19",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "507.21 617.19 389.6 617.19 795.78 -7.86 913.39 -7.86 507.21 617.19",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-6.15 617.19 -123.76 617.19 282.42 -7.86 400.03 -7.86 -6.15 617.19",
    fill: "#fff"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 395.56,
    cy: 590.47,
    rx: 312.65,
    ry: 28.28,
    fill: "#bbdefb",
    opacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M305.29,474.8s-3.71,37.64-1.13,54.62a2.1,2.1,0,0,1-.9,2.05l-3.06,2a2.64,2.64,0,0,0-1.15,1.91l-.12,1.08a3.33,3.33,0,0,0,.95,2.68l4,4s5.71-12.43,13-5.5a284.4,284.4,0,0,1,10.8-56.43,27.3,27.3,0,0,0,2.44-8.76l-20,2.25Z",
    fill: "#f9b499"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M328.67,539l-.66-58.7a22.21,22.21,0,0,0,2.13-7.82l7.61-1s6.18-2.12,15.1,5.46c0,0-1.45,27-7.85,42.45,0,0-4.41,14.34-4,20.74,0,0-5.08-8.61-9.49.66C331.54,540.74,329.56,541.4,328.67,539Z",
    fill: "#f9b499"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 209.94,
    y: 354.43,
    width: 4.35,
    height: 106.75,
    fill: "#e6e7e8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 241.18,
    y: 353.61,
    width: 4.35,
    height: 106.75,
    fill: "#e6e7e8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 413.54,
    y: 579.74,
    width: 5.99,
    height: 14.67,
    fill: "#243E59"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 416.38,
    cy: 599.65,
    r: 9.73,
    fill: "#243E59"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.57,
    cy: 599.65,
    r: 9.73,
    fill: "#EC1C24"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 442.87,
    y: 586.03,
    width: 5.99,
    height: 14.67,
    fill: "#243E59"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 496.75,
    y: 581.24,
    width: 5.99,
    height: 14.67,
    fill: "#243E59"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 496.75,
    y: 581.24,
    width: 5.99,
    height: 14.67,
    opacity: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 438.08,
    y: 599.2,
    width: 16.16,
    height: 19.16,
    rx: 7.52,
    fill: "#243E59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M462.93,583.93h13.77a0,0,0,0,1,0,0v11.25a6.4,6.4,0,0,1-6.4,6.4h-1a6.4,6.4,0,0,1-6.4-6.4V583.93a0,0,0,0,1,0,0Z",
    fill: "#243E59"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M462.93,583.93h13.77a0,0,0,0,1,0,0v11.25a6.4,6.4,0,0,1-6.4,6.4h-1a6.4,6.4,0,0,1-6.4-6.4V583.93a0,0,0,0,1,0,0Z",
    opacity: 0.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 498.09,
    cy: 599.65,
    rx: 6.73,
    ry: 8.53,
    fill: "#243E59"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 501.54,
    cy: 599.65,
    rx: 7.48,
    ry: 8.53,
    fill: "#EC1C24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M397.08,549.81S362.21,569,374.63,576.75c0,0,7.18,9.28,37.11-3.89L424,548.62Z",
    fill: "#EC1C24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M389.38,469.07a63.39,63.39,0,0,0-4.83-21.29,46.54,46.54,0,0,1-3.34-13.2L371,361.85a158,158,0,0,0-3-16.16l16.46,4.49,16.16,9.27,28.73,87.4L424,548.62l-26.94,1.19S390.86,495.62,389.38,469.07Z",
    fill: "#243E59"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M389.38,469.07a63.39,63.39,0,0,0-4.83-21.29,46.54,46.54,0,0,1-3.34-13.2L371,361.85a158,158,0,0,0-3-16.16l16.46,4.49,16.16,9.27,28.73,87.4L424,548.62l-26.94,1.19S390.86,495.62,389.38,469.07Z",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M384.51,350.18S412,398.07,412,443.26c0,0-.39,1.58,1.71,5.06a15.64,15.64,0,0,1,2.23,6.75l8,93.55,35.91-.9-5.68-114L448,347.78Z",
    fill: "#243E59"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M408.45,471.69V572.86s.9,12.27,17.66,14.67l20.05,5.08a9.39,9.39,0,0,0,5.69.3l48.79-130.79s-9.28-11.08-24.25-9.58l-47.89.3S412,452.84,408.45,471.69Z",
    fill: "#EC1C24"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M408.45,471.69V572.86s.9,12.27,17.66,14.67l20.05,5.08a9.39,9.39,0,0,0,5.69.3l48.79-130.79s-9.28-11.08-24.25-9.58l-47.89.3S412,452.84,408.45,471.69Z",
    opacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M375.23,351.07s-5.09.3-7.78-6.58c0,0-2.1-6.29-3.6-11.08,0,0-1.1-32.81,1.81-57.23a160.45,160.45,0,0,0,.54-33.37l-1.45-15.95,6.75-4.38s10.31-14.18,22.29-17.77c0,0,2.48,8.15,9.87,5.69.9-.3,4.49.3,10.78-7.18l7.78-7.19s31.73,6.29,38.61,23.05c0,0,23.94,46.09,17.66,59.56l-2.69,6.29s2.09-11.68-7.79-14.37c0,0-13.47-3.59-15.56,12a8.1,8.1,0,0,1-2.69-7.48s-3-9.58-3-2.69l2.7,38.61,1.76,26.94a13.81,13.81,0,0,1-2.72,9.16l-.54.71Z",
    fill: "#EC1C24"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M375.23,351.07s-5.09.3-7.78-6.58c0,0-2.1-6.29-3.6-11.08,0,0-.87-31.67,1.85-55.94a187.67,187.67,0,0,0,0-38l-.95-12.62,6.75-4.38s10.31-14.18,22.29-17.77c0,0,2.48,8.15,9.87,5.69.9-.3,4.49.3,10.78-7.18l7.78-7.19s31.73,6.29,38.61,23.05c0,0,23.94,46.09,17.66,59.56l-2.69,6.29s2.09-11.68-7.79-14.37c0,0-13.47-3.59-15.56,12a8.1,8.1,0,0,1-2.69-7.48s-3-9.58-3-2.69l2.7,38.61,1.76,26.94a13.81,13.81,0,0,1-2.72,9.16l-.54.71Z",
    fill: "#fff",
    opacity: 0.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "298.2 308.88 299.76 308.88 299.58 301.46 296.85 301.51 298.2 308.88",
    fill: "#f7a48b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M328.72,221.05s12.15,4.89,18.13-7.87l8.15,4.07-8.69,32.05-22.82-.81L323,225.94Z",
    fill: "#f9b499"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M328.72,221.05l-1.43,10s22.82-.81,19.56-17.92C346.85,213.18,342.37,225.4,328.72,221.05Z",
    fill: "#f7a48b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M311.48,228.68l-8.36.52s-2.45,29.61-5.44,35.32c0,0-4.34,9.78,1.9,24.17V311s28.25,7.87,58.41,1.63c0,0-.27-17.12,1.63-28,0,0-.69,1.81,5,4.8l3.11-26.86-28-17.47s-5.37,4.21-11.07-1Z",
    fill: "#EC1C24"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 334.2,
    cy: 195.28,
    rx: 17.51,
    ry: 26.99,
    fill: "#f9b499"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M315.27,192.94s-2.65-23,16.3-28.52c0,0,16.09-3.26,21.19,3.66,0,0,12.83-1,13.85,13.65,0,0-.81,3.67,1.43,5.71,0,0,5.29,5.3,3,11.61,0,0-1.83,3.87.41,7.13,0,0,5.5,6.11.41,10.6,0,0-2.45,2.85-.41,5.7,0,0,5.09,5.91-.61,9,0,0-2.45,2-.2,5.3,0,0,6.11,3.46.2,9.17,0,0-1.43,3.05.41,5.5,0,0,3.05,3.67-2.65,5.3,0,0-1.95,1.46-1.06,3.37a4.26,4.26,0,0,1,.4,2.55c-.26,1.44-1.2,3.12-4.23,2.63,0,0-3.06.21-2.45,2.65,0,0,2.45,5.91-3.26,6.32,0,0-3.46-1-3.66,2.65,0,0,1.83,5.5-3.06,5.09a3.92,3.92,0,0,0-4.68.81s-1.63,4.28-5.91,2.86c0,0-1.63-.41-1.63-4.08,0,0,.2-1.63-2.65-2.85a2.82,2.82,0,0,1-.61-4.69s2.44-1.83-.21-4.89c0,0-2.85-3.46,1.23-6.52a5.8,5.8,0,0,0,.2-6.11s-3.06-2.44,1.43-5.7c0,0,2.44-1.84,1.22-5.71,0,0-1.83-4.48,2.44-5.5,0,0,5.3.41,2.65-5.91,0,0-3.46-3.25.61-6.31,0,0,3.06-1.63.61-4.89,0,0-2-3.26.62-5.91,0,0,2.24-2-1-5.09,0,0-3.87-2.24.61-8.15,0,0,3.26-4.28.41-5.3,0,0-10.39-2.65-13.25-24.24,0,0-3.87-7.95-12.42,3.67a37.57,37.57,0,0,0-1.43,32.18,20.37,20.37,0,0,0,9.17,11.41s.34,3.13,2.1,4.35c0,0,.82,2.85-.95,4.48a4.41,4.41,0,0,0,.27,5.84,3.44,3.44,0,0,1-.13,4.89s-2.85.68-1.36,3.53a5,5,0,0,1-1.09,6.79s-1.9,1.5-.4,4.21c0,0,2.71,4.35-.82,6.93a2.41,2.41,0,0,0-.14,3.53s2.31,1.63-2.3,4.62a2.7,2.7,0,0,1-3.26,2.72s-1.91.27-2.86-4.49c0,0-3.93-3.66-2.58-7.47,0,0-5.57-3.53-1.63-8.82,0,0,1.36-2.31-.4-5.57,0,0-3.81-2.18-.41-6,0,0,3.12-3,.27-5.84,0,0-4.35-.81-.41-8.83,0,0,1.63-2.31,0-6a5.28,5.28,0,0,1,.55-7.2s3.39-2.31.13-5.84c0,0-2.44-2.72.68-6.66A11.8,11.8,0,0,0,315.27,192.94Z",
    fill: "#243E59"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M303.12,229.2s-10.25-.27-17.85,27.15a1.67,1.67,0,0,0-.06.59l4.05,46.15,10.32-1.63V288.69s-5.72-12.21-1.9-24.17C297.68,264.52,300.67,260.88,303.12,229.2Z",
    fill: "#EC1C24"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M303.12,229.2s-10.25-.27-17.85,27.15a1.67,1.67,0,0,0-.06.59l4.05,46.15,10.32-1.63V288.69s-5.72-12.21-1.9-24.17C297.68,264.52,300.67,260.88,303.12,229.2Z",
    opacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M299.58,311l-.41,13.82a18.7,18.7,0,0,1-1.23,6.14c-3.83,10-16.19,48.74-16.67,135.31a5.94,5.94,0,0,0,5.12,5.92L304,474.64a24.28,24.28,0,0,0,6.2.07l27.59-3.28a16.18,16.18,0,0,1,11,2.69l4.08,2.77s15.32.76,26.54-5.46a10.68,10.68,0,0,0,5.34-10.79L370.66,358.05s-.7-9.38-9.56-31.2a17.09,17.09,0,0,1-.93-3.11L358,312.6S333,318.87,299.58,311Z",
    fill: "#243E59"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M291.26,252.79s-.23,9.72-3.19,15.73l-5.5-1.63-5.6-5.4-.2-7,7.3-.26Z",
    fill: "#f7a48b"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M302.13,268a6.92,6.92,0,0,1-1.1-.1c-9.12-1.63-15.09-13.51-15.34-14l.74-.37c.06.12,6,12,14.75,13.57a5.65,5.65,0,0,0,5-1.65,23.44,23.44,0,0,0,6.05-11.65l.8.17A24.19,24.19,0,0,1,306.77,266,6.5,6.5,0,0,1,302.13,268Z",
    fill: "#243E59"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M324.08,277.74c-9.93,0-19.22-29.22-19.61-30.48l.78-.25c.1.31,9.5,29.91,18.87,29.91h.3c.12,0,5.61.16,10.88-8l.69.45c-5.55,8.59-11.32,8.39-11.56,8.37Z",
    fill: "#243E59"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M303.86,527.87s-1.12-.2-3.26,1.94c0,0-10.39,7.94-9.47,11.2,0,0-1.33,10.8,2.44,14.06l1.53,1.73s-5.4,30.87,13,30.46c0,0,16.5,3,14.57-10.29,0,0-1.12-7.33-4.79-11.82,0,0-.31-12.22,1.83-19.25,0,0,2.24-5.91-2.85-8.25,0,0-6.11-7.44-13,5.5l-4.17-4.38a3.46,3.46,0,0,1-.64-3.36S299,534,301,533l2.25-1.49S304.88,531,303.86,527.87Z",
    fill: "#EC1C24"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M323.38,567.44s-4.19-2.21,0-19.42c0,0,3.31-11.47,5.29-12.13V539a2.29,2.29,0,0,0,2.87,1.76s4.28-9.44,9.49-.66l.43,12.8a6.92,6.92,0,0,0,2,4.7c3.1,3.13,8.57,9.73,5.33,14.79a5.41,5.41,0,0,1-4.43,2.42l-11.5.31a5.64,5.64,0,0,1-3.42-1A25.67,25.67,0,0,1,323.38,567.44Z",
    fill: "#EC1C24"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M493.78,589.33l-34.32,4.59a17,17,0,0,1-19.32-16.87l-.22-101a16.89,16.89,0,0,1,16.89-16.93l35.19.18a15.52,15.52,0,0,1,15.52,15.09L511,568.85A19.92,19.92,0,0,1,493.78,589.33Z",
    fill: "#243E59"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 454.6,
    y: 334.9,
    width: 4.84,
    height: 119.9,
    fill: "#e6e7e8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 427.04,
    y: 333.04,
    width: 5.21,
    height: 123.25,
    fill: "#e6e7e8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 422.95,
    y: 325.6,
    width: 41.33,
    height: 10.8,
    rx: 5.02,
    fill: "#EC1C24"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M434.86,325.22s-3.35,16,5.59,11.55c0,0,9.31,5.58,15.26-.38,0,0,3.73-8.56-1.11-19.36,0,0,18.19-23.25,21.2-32.1,0,0,1.51-15.56-10.78-14.44,0,0-10.25-2.35-12.57,12l-7.16,27.8s-9.31,6-13.78,8.94c0,0-6.33,3-3.17,6.33Z",
    fill: "#f9b499"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M393.79,204.71l-.12-15.07,30.05-19.18L422.22,196s-10,19.83-22.16,17.59C400.06,213.62,391.66,212.75,393.79,204.71Z",
    fill: "#f9b499"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M194.39,457.4h65.49a11.88,11.88,0,0,1,11.88,11.88v95.63a17,17,0,0,1-17,17H199.46a17,17,0,0,1-17-17V469.28A11.88,11.88,0,0,1,194.39,457.4Z",
    fill: "#EC1C24"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 206.14,
    y: 348.18,
    width: 42.65,
    height: 8.15,
    rx: 3.79,
    fill: "#EC1C24"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M211.53,462a1.24,1.24,0,0,1-1.05-1.89c.3-.49,7.57-12.17,17.43-11.61,1,0,15,.28,17.19,11.21a1.23,1.23,0,1,1-2.42.49C240.8,451,228,451,227.89,451h-.09c-8.38-.45-15.15,10.33-15.21,10.44A1.25,1.25,0,0,1,211.53,462Z",
    fill: "#EC1C24"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 182.51,
    y: 564.71,
    width: 7.46,
    height: 16.79,
    rx: 3.47,
    fill: "#243E59"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 264.03,
    y: 565.15,
    width: 7.46,
    height: 16.79,
    rx: 3.47,
    fill: "#243E59"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M273.48,239.14l3,15.77a1.06,1.06,0,0,0,1.24.83l23.5-5.25-3.46-18.33-23.49,5.77A1,1,0,0,0,273.48,239.14Z",
    fill: "#EC1C24"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "306.2 248.56 301.21 250.49 297.75 232.16 303.25 232.36 306.2 248.56",
    fill: "#EC1C24"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "306.2 248.56 301.21 250.49 297.75 232.16 303.25 232.36 306.2 248.56",
    opacity: 0.4
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M284.92,238.72a4.75,4.75,0,0,1,.58,0c1.37,0,4.8.3,6.51,3.48a6.56,6.56,0,0,1,.72,3.72c-.23,2.3-1.54,5.89-7.52,5.89Z",
    opacity: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.11,
    cy: 245.25,
    r: 6.38,
    fill: "#EC1C24"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "291.33 234.6 296.63 233.38 297.57 238.17 292.45 239.49 291.33 234.6",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M290.94,315.23c-3.36-1.14-9.21-5.1-11-19l-.87-17.76a3.89,3.89,0,0,0-1.17-2.51c-.62-.63-1.24-2.09-1-5.44a4.45,4.45,0,0,0-1-3.08L270,260.31a5.5,5.5,0,0,1-1.11-2.26c-.38-1.63-.75-4.28.56-5.06l-.29-6.46a4.06,4.06,0,0,1,4.68-4.2,11.19,11.19,0,0,1,3.21,1.13,1,1,0,0,1,.45,1.34,2.78,2.78,0,0,1-2.57,1.43,1.85,1.85,0,0,0-1.72,1.23c-.22.67,0,1.45,1.87,1.84l11,5.68a1.65,1.65,0,0,1,.88,1.68h0a1.65,1.65,0,0,1-2,1.39l-6.86-1.47a.25.25,0,0,0-.16.48L286.5,261a1.07,1.07,0,0,1,.57,1.3h0a1.07,1.07,0,0,1-1.31.7L280,261.37a.39.39,0,0,0-.33.7l6.67,4.66a5.33,5.33,0,0,1,1.76,2.12c2.09,4.64,9,20.43,9.69,28,0,0,2.73,12.29-2.14,17.28A4.55,4.55,0,0,1,290.94,315.23Z",
    fill: "#f9b499"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M282.67,240.82a3.65,3.65,0,0,1,.41,0,4.94,4.94,0,0,1,4.51,2.41,4.45,4.45,0,0,1,.5,2.58c-.15,1.6-1.06,4.09-5.21,4.09Z",
    opacity: 0.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.11,
    cy: 245.35,
    r: 4.43,
    fill: "#EC1C24"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.11,
    cy: 245.35,
    r: 2.19,
    opacity: 0.2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M393.84,191.31l0,13.4s17.47-2.59,22.9-23.06Z",
    fill: "#f7a48b"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400.93,
    cy: 164.71,
    rx: 19.66,
    ry: 30.37,
    fill: "#f9b499"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M383.44,127.3s-3.52,10.87,1.92,17.91h15s13.43.64,16.63,20.14h9.91a31.25,31.25,0,0,0-.64-29.41s-5.44-8.32-22.06-5.76C404.22,130.18,390.79,134,383.44,127.3Z",
    fill: "#243E59"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 422.83,
    cy: 168.06,
    rx: 5.11,
    ry: 6.87,
    fill: "#f9b499"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M479.12,455.9a1.22,1.22,0,0,1-1-.45c-.5-.61-1-1.3-1.62-2-2-2.61-4.57-5.86-6.83-7.37a15.86,15.86,0,0,0-12.63-2.12,21.89,21.89,0,0,0-13.66,10.29c-.26.46-.4.74-.41.76a1.23,1.23,0,0,1-1.65.57,1.24,1.24,0,0,1-.58-1.65s.17-.34.5-.91a24.38,24.38,0,0,1,15.24-11.47A18.42,18.42,0,0,1,471.09,444c2.59,1.73,5.26,5.16,7.4,7.91.57.72,1.1,1.4,1.58,2a1.23,1.23,0,0,1-.95,2Z",
    fill: "#EC1C24"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.12,455.9a1.22,1.22,0,0,1-1-.45c-.5-.61-1-1.3-1.62-2-2-2.61-4.57-5.86-6.83-7.37a15.86,15.86,0,0,0-12.63-2.12,21.89,21.89,0,0,0-13.66,10.29c-.26.46-.4.74-.41.76a1.23,1.23,0,0,1-1.65.57,1.24,1.24,0,0,1-.58-1.65s.17-.34.5-.91a24.38,24.38,0,0,1,15.24-11.47A18.42,18.42,0,0,1,471.09,444c2.59,1.73,5.26,5.16,7.4,7.91.57.72,1.1,1.4,1.58,2a1.23,1.23,0,0,1-.95,2Z"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M496.78,405.87s-20.16,4.82-16,13.44c0,0,3.49,4.42,9.86-3.71,0,0-5.21,17.79-.79,22.6,0,0-1.2,15.55-7.35,16.67,0,0-8.35.63-2.81,7.44,0,0,6.63,9.13,13.47-.87,0,0,3.59-9.3,2.69-18.31,0,0,7.47,2.5,10.13,1.11,0,0-6.21,26.65,7.09,28l1.32-14.53,2.93-48.65Z",
    fill: "#EC1C24"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 491.61,
    cy: 386,
    r: 6.05,
    fill: "#EC1C24"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 508.49,
    cy: 395.51,
    rx: 16.23,
    ry: 16.83,
    transform: "translate(-9.62 778.33) rotate(-74.34)",
    fill: "#EC1C24"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 508.49,
    cy: 395.51,
    rx: 16.23,
    ry: 16.83,
    transform: "translate(-9.62 778.33) rotate(-74.34)",
    opacity: 0.2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M490.6,415.6s-4.59,5.71-2,9.42a5.79,5.79,0,0,0,3.86.83,2.87,2.87,0,0,0,2.26-3.06,2,2,0,0,0-1.16-1.67,4.74,4.74,0,0,1-1.87-1.37A5.1,5.1,0,0,1,490.6,415.6Z",
    fill: "#f9b499"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M522.83,566.5s-15.72,4.62-11,7.75c0,0,3.78,6.74,35.28.57a32.41,32.41,0,0,1,7.39-1.15,2.47,2.47,0,0,0,2.44-2c.88-4.26,2-12.92-3-13.54L547.46,554S538.69,568,522.83,566.5Z",
    fill: "#EC1C24"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M532.64,487.38s6.57,51.48,6.17,67.61a5.72,5.72,0,0,1-3.11,4.94l-12.87,6.57s3.26,3.59,12.31,2.17a24.34,24.34,0,0,0,12.76-6.45,19.82,19.82,0,0,1,6-4.07l1.18-70.88S543.07,487.57,532.64,487.38Z",
    fill: "#f9b499"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M605.46,566.74s-2.2,16.78,4.08,14.76c0,0,10-4,11.33-19.4l4.26-15.34s3.39-12-6.5-11.26c0,0-4,.61-6-2.3Z",
    fill: "#EC1C24"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M533.3,320.41s-8.18.49-7.82,6.69c0,0-1.48,8.31-6.64,5.95a8.14,8.14,0,0,0,9,6.59l14.63-14.87Z",
    fill: "#243E59"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M530.81,313.05l3.37,11.29s-6.45,6.71-1.33,6.26c0,0,13.26-1.52,21.67-11.47l-2.86-1.49L550.79,307l-2.29-14.18Z",
    fill: "#f9b499"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 532.05,
    cy: 291.52,
    rx: 24.95,
    ry: 16.49,
    transform: "translate(200.38 799.52) rotate(-85.58)",
    fill: "#f9b499"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M537,288.09s-5.59,11.86,9.17,13c0,0,5,0,5.5,16.55l2.86,1.49,10.18,5.45s18.58,1,11.76,28.9l-1.31,16.86s6.45,4.32,9-1c0,0-6.13-3-3.7-12.59,0,0,2.66,4,6.16,2.6,0,0-6.54-8.56-3.2-13.39,0,0,6.84-6.26-2.07-11.61,0,0-4.54-1.63-1.94-7.79,0,0,3.44-6.09-8.53-4.9,0,0-4.22-.32-6-9.79A97.77,97.77,0,0,1,537,288.09Z",
    fill: "#243E59"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 545.67,
    cy: 304.66,
    rx: 4.86,
    ry: 3.59,
    transform: "translate(199.84 825.22) rotate(-85.58)",
    fill: "#f9b499"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M522.5,266.51c.2,1.74,1.19,4.17,3.9,7.47,0,0,15.33,25.24,38.43,37.89,0,0,8.83,2.63-2-8.34,0,0-8.92-2-17.3-14.27a58.85,58.85,0,0,0-5.22-6.66c-4.29-4.7-11.3-13.33-7.79-16.13a9.53,9.53,0,0,0-6-3.74A3.43,3.43,0,0,0,522.5,266.51Z",
    fill: "#EC1C24"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M532.52,266.47,544,260.9s4.63-4.25,13.62,2.59c0,0,17,17.91,14.82,23l-9.62,17.08s-9.9-2.53-17.31-14a53.68,53.68,0,0,0-5.51-7.23C535.76,277.71,529.28,269.63,532.52,266.47Z",
    fill: "#EC1C24"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M534.18,324.34h0c-.06,0-10,6.33-10.41,15.49,0,0-4.92,23.89-.79,34,0,0,.76.54,2.76-.08a15.42,15.42,0,0,1,10.61.34c.61.27,1.25.57,1.9.92,0,0,11.54,1.82,17.51-3.86,0,0-.82-9.28-1.53-16.1,0,0-14.56-10.34-7.53-21.78,0,0,5.49-7.32,18-8.73l-10.18-5.45s-5.36,8-21.67,11.47C532.85,330.6,527.81,331.21,534.18,324.34Z",
    fill: "#EC1C24"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M554.23,355.09s0-7.68,11.78-9.23c0,0,8,.31,10.54,6.66a28.36,28.36,0,0,0,1.26-15.07,17.52,17.52,0,0,0-5.95-10,11,11,0,0,0-7.16-2.89s-18.65,1.31-20,14.41C544.73,339,543.22,346.56,554.23,355.09Z",
    fill: "#EC1C24"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M554.23,355.09s0-7.68,11.78-9.23c0,0,8,.31,10.54,6.66a28.36,28.36,0,0,0,1.26-15.07,17.52,17.52,0,0,0-5.95-10,11,11,0,0,0-7.16-2.89s-18.65,1.31-20,14.41C544.73,339,543.22,346.56,554.23,355.09Z",
    opacity: 0.2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M523,373.87s-12.54,47-8.63,83.83c0,0-.84,17.57-3.81,26.16a3.55,3.55,0,0,0,2.11,4.51c2.37.88,6.6,1.25,14.11-.53,0,0,26.6-1.76,45.94,1a9.13,9.13,0,0,1,2.16.6c2.71,1.12,10.72,3.38,8.17-10.15l-3.44-23-16.88-87.64-7,2.54s-5.18,5-17.51,3.86c0,0-7.08-4.2-12.51-1.26A7.36,7.36,0,0,1,523,373.87Z",
    fill: "#243E59"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M510.54,483.86s11.2-2.55,14.17-17.07c0,0,4.23-11,3.65-27.37,0,0,3.25,18.07,6.52,25.55a29,29,0,0,1,1.86,5.58c1.06,5,2.11,13.41-1.94,16.69l-8,.6S508.72,492.37,510.54,483.86Z",
    opacity: 0.2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M571.54,488.85A35.42,35.42,0,0,0,574.19,478,17.55,17.55,0,0,0,565,461.58c-4.38-2.48-9.1-7.89-5.44-19.44a30.74,30.74,0,0,0,1.47-11.3c-.9-13.95-3.54-46.27-9.13-57.19l3.88-2.46,7-2.54,18.15,95.11L583,479.29s3.76,14.47-8.17,10.15Z",
    opacity: 0.2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M554.66,512.43,534.07,500.7l-1.43-13.32s19.69-.33,22.43-.11Z",
    fill: "#f7a48b"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M545.56,487.15s-1.44,10.64,9.44,13c0,0,27.26,14.84,47.78,44.77a7.81,7.81,0,0,1,1.32,3.79l1.36,18s10.22-1,9.33-17.4l-2.13-16.14s-17.87-23.2-37.13-40.36c0,0-1.8-1-.67-3.4A152.16,152.16,0,0,0,545.56,487.15Z",
    fill: "#f9b499"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M554.23,355.09s.91,24,10.37,56.72c0,0,5.84,11.82,3.35,24.22,0,0-8.82,14.68-4,16,0,0,2.93,1.76,6.36-6.88l3.71,7.66s.12,14.44,4.44,14.16c0,0,2.89,2.38,2.52-16.7,0,0,.08-20.88-1.25-43.42l-4.3-34.24a22.67,22.67,0,0,1-.1-4.51l1.22-15.56s-3.38-8.18-11.82-6.38C564.73,346.14,554.68,347.27,554.23,355.09Z",
    fill: "#f9b499"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigration);
export default __webpack_public_path__ + "static/media/migration.0bfa9d93f25a16326ade82c68a130910.svg";
export { ForwardRef as ReactComponent };